import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from 'ui/src/components/Theme';

import headerCommonTheme from './common';

import headerBlogTheme from './_blog';
import headerSiteTheme from './site';
import { type HeaderBGType } from '../types/_bg';
import { type HeaderThemeProps } from '../types/_theme';

const headerThemes = ({ bg }: { bg?: HeaderBGType }) =>
  new MatchedMap([
    [ThemeEnum.Blog, headerBlogTheme({ bg })],
    [ThemeEnum.Site, headerSiteTheme({ bg })],
  ]);

const useHeaderTheme = (themeArgs: HeaderThemeProps) => useTheme(headerCommonTheme, headerThemes(themeArgs));

export default useHeaderTheme;
